'use client';

import { ChatMessage, MessageType } from '../types/chat.types';
import SearchIcon from '@src/assets/svg/searchIcon';
import Sparkle from '@src/assets/svg/sparkle';
import ReactMarkdown from 'react-markdown';

type Props = {
  message: ChatMessage;
};

export default function ChatMessageItem({ message }: Props) {
  // const isUser = message.type === MessageType.USER;
  const isQuick = message.type === MessageType.QUICK_SUGGESTION;
  const isAI = message.type === MessageType.AI;
  const isProgress = message.type === MessageType.PROGRESS;
  // const isStreaming = isAI && message.status === 'streaming';
  const isLoadingPlaceholder = message.content === 'Loading...';

  const isLeft = isAI || isQuick || isProgress;

  return (
    <div
      className={`
        flex
        ${isLeft ? 'justify-start' : 'justify-end'}
      `}
    >
      {isLeft ? (
        /* Left Side Wrapper (AI + Quick Suggestions + Progress) */
        <div
          className={`flex  justify-center pt-2 ${
            isAI ? 'items-start' : 'items-center'
          }`}
        >
          <div className="flex h-[32px] w-[32px] items-center justify-center shrink-0">
            {isAI && (
              <div className="flex h-full w-full   items-center justify-center rounded-full  bg-[#006CFF]">
                <Sparkle />
              </div>
            )}
            {isQuick && (
              <div className="">
                <SearchIcon />
              </div>
            )}
            {isProgress && (
              <div className="">
                <div className="w-1 rounded-full bg-[#006CFF] h-5 " />
              </div>
            )}
          </div>

          {/* Message Bubble */}
          {isLoadingPlaceholder ? (
            /* iMessage-style typing indicator */
            <div className="flex items-center gap-[5px] rounded-2xl bg-[var(--Color-Themes-Gray-200,#EDEDED)] px-[12px] py-[10px] ml-1">
              <span
                className="block h-2 w-2 rounded-full bg-[#8E8E93] animate-bounce"
                style={{ animationDelay: '0ms', animationDuration: '1s' }}
              />
              <span
                className="block h-2 w-2 rounded-full bg-[#8E8E93] animate-bounce"
                style={{ animationDelay: '160ms', animationDuration: '1s' }}
              />
              <span
                className="block h-2 w-2 rounded-full bg-[#8E8E93] animate-bounce"
                style={{ animationDelay: '320ms', animationDuration: '1s' }}
              />
            </div>
          ) : (
            <div
              className={`
                rounded-2xl
                ${!isAI ? 'py-2' : 'pb-2'}
                px-3
                text-[16px]
                font-medium
                tracking-[-0.48px]
                font-[Geist]
                text-[var(--Color-Themes-Gray-1000,#171717)]
                ${isProgress ? 'opacity-50' : ''}
                ${isProgress ? ' animate-pulse' : ''}
              `}
            >
              <ReactMarkdown
                components={{
                  p: ({ children }) => (
                    <p style={{ whiteSpace: 'pre-wrap' }}>{children}</p>
                  ),
                }}
              >
                {message.content}
              </ReactMarkdown>
            </div>
          )}
        </div>
      ) : (
        /* User Message (Right Bubble) */
        <div
          className="
            max-w-[75%]
            rounded-2xl
            px-2
            py-2
            text-[16px]
            font-medium
            tracking-[-0.48px]
            font-[Geist]
            text-[var(--Color-Themes-Gray-1000,#171717)]
            bg-[var(--Color-Themes-Gray-200,#EDEDED)]
          "
        >
          {message.content}
        </div>
      )}
    </div>
  );
}
